import { Component, Input, OnInit } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { Anchor, AlertSeverity, Colors, Icons } from '../../../utilities/enum';
import { AlertService } from '../../../services/utilities/alert.service';

@Component({
    selector: 'atom-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('250ms ease-out', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('250ms ease-in', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})

export class SnackbarComponent implements OnInit {

    @Input() animation = true;
    @Input() type = 'primary';
    @Input() severity = AlertSeverity.Info;
    @Input() position = 'sticky';
    @Input() anchor = Anchor.Top;
    @Input() marginTop = this._alertService.margin.top;
    @Input() marginBottom = this._alertService.margin.bottom;
    @Input() gap = 0;
    @Input() full = false;
    @Input() show = false;
    @Input() menuOpen = true;
    @Input() class: string;
    @Input() showClose = true;

    icons = Icons;
    colors = Colors;
    anchorEnum = Anchor;
    menuClosed = false;
    showAlerts = true;


    constructor(private readonly _alertService: AlertService) {
        this.showAlerts = _alertService.alertsVisible;
    }

    ngOnInit(): void {
        this._alertService.menuClosed.subscribe((state) => {
            this.menuClosed = state;
        });
    }

}
